import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LabelValue from './LabelValue';
import { ProviderAddress } from '../data/models/address.model';
import { useZipCode } from '../hooks/useZipCode';
import { FULLSTORY_MASK_CLASSNAME } from '../services/analyticsUtils';

interface AddressDisplayProps {
  address?: ProviderAddress;
  addressLabel?: string;
  showCounty?: boolean;
}

export default function AddressDisplay({
  address,
  addressLabel,
  showCounty = false,
}: AddressDisplayProps) {
  const { t } = useTranslation('common');

  return (
    <>
      {addressLabel && (
        <Grid item xs={12}>
          <Typography>{addressLabel}</Typography>
        </Grid>
      )}
      <Grid item xs={6}>
        <LabelValue
          label={t('common.address1')}
          value={address?.addressLine1}
          className={FULLSTORY_MASK_CLASSNAME}
        />
      </Grid>
      <Grid item xs={6}>
        <LabelValue
          label={t('common.address2')}
          value={address?.addressLine2}
          className={FULLSTORY_MASK_CLASSNAME}
        />
      </Grid>
      <Grid item xs={6}>
        <LabelValue
          label={t('common.city')}
          value={address?.city}
          className={FULLSTORY_MASK_CLASSNAME}
        />
      </Grid>
      <Grid item xs={6}>
        <LabelValue
          label={t('common.state')}
          value={address?.stateCode}
          className={FULLSTORY_MASK_CLASSNAME}
        />
      </Grid>
      <Grid item xs={6}>
        <LabelValue
          label={t('common.zip')}
          value={useZipCode(address?.zipCode)}
          className={FULLSTORY_MASK_CLASSNAME}
        />
      </Grid>
      {showCounty ? (
        <Grid item xs={6}>
          <LabelValue
            label={t('common.county')}
            value={address?.county}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
}
